import { Plan, PlanV2 } from '@zapier/design-system-revenue/src/types';

export const isFree = (plan: Plan | PlanV2 | null | undefined) =>
  Boolean(plan?.amount === 0);
